const PAGE_HEADS = {
  home: {
    title: '化化网官网-装修与自建房服务保障平台-提供家装、公装、自建房翻新与新建服务',
    meta: [
      { name: 'description', content: '化化网是一个装修与自建房服务保障平台，汇聚本地优质的装修公司、设计师、工人等服务商，提供家装、工装/公装、自建房等设计施工服务，满足业主新房装修、旧房翻新、局部改造、别墅装修、办公室装修、商铺装修、自建房翻新与新建等需求。平台提供装修攻略、装修案例、 口碑评价、在线报价、在线签约、资金托管、先装后付、在线验收、平台托底保障等服务，让装修与建房更简单、更透明、更规范、更放心。' },
      { name: 'keywords', content: '化化网,化化装修,家装平台, 装修网站, 装修公司, 自建房, 新房装修,旧房翻新,局部改造,别墅装修,办公室装修,商铺装修,装修设计,装修保障' }
    ]
  },
  decorationServices: {
    title: '装修设计与施工服务-家庭装修、办公室装修、商铺装修等-化化网',
    meta: [
      { name: 'description', content: '化化网提供本地靠谱的装修公司、设计师及装修工人师傅，提供全屋装修、旧房翻新、局部改造、别墅装修、办公室装修、商铺装修等服务，平台采用先装后付模式，节点验收满意再付款，平台提供托底保障，致力服务至业主满意为止。平台还有权威的装修攻略、避坑干货，真实的装修案例,真实的业主口碑评价,帮助你更快的找到靠谱的装修公司、设计师与工人。' },
      { name: 'keywords', content: '化化网,化化装修,装修公司, 设计师, 装修工人,新房装修,旧房翻新,局部改造,别墅装修,办公室装修,商铺装修,装修设计,装修保障' }
    ]
  },
  selfBuildServices: {
    title: '自建房设计与施工服务-农村自建房、乡村别墅的翻新与新建-化化网',
    meta: [
      { name: 'description', content: '化化网自建房设计与施工服务，提供先建后付、平台担保交易服务，通过节点验收、资金托管、平台托底等特色保障服务，保障业主权益。化化网严选施工队，在线监工，全程透明留痕，建房子不再提心吊胆。' },
      { name: 'keywords', content: '化化网,自建房,农村自建房,乡村别墅,自建房施工队,乡村别墅翻新,自建房翻新,平台托底保障' }
    ]
  },
  settleIn: {
    title: '服务商入驻-诚邀优质装企、施工队、设计师、工人入驻-化化网',
    meta: [
      { name: 'description', content: '化化网诚邀优质装修公司、设计师、工人等从业者入驻化化平台。我们将为服务商提供海量精准装修业主流量、专业品牌展示、业绩积累、高效订单管理工具、交易保障及平台信任背书,助力服务商IP打造与变现。免费加入化化平台,在线接单,自主经营,打造属于自己的品牌。' },
      { name: 'keywords', content: '服务商入驻,装修公司入驻,施工队招募,化化网合作伙伴,设计师入驻,工人入驻' }
    ]
  },
  about: {
    title: '关于我们-化化网',
    meta: [
      { name: 'description', content: '了解化化网，选择化化装修平台，是业主找装修的放心之选。我们致力于通过“先装后付、在线验收、平台托底”重建装修信任，让每一次服务值得托付。我们期待为您创造放心、省心、优质的装修体验。' },
      { name: 'keywords', content: '关于化化网,化化网团队,先装后付平台,装修平台介绍,化化网介绍,化化网价值观,企业愿景,企业故事' }
    ]
  }
}

export function getPageHead(name, canonical) {
  const head = PAGE_HEADS[name]
  if (!head) return {}

  return {
    title: head.title,
    meta: head.meta.map(item => ({ ...item })),
    ...(canonical ? { link: [{ rel: 'canonical', href: canonical }] } : {})
  }
}
